import React, { Component, Fragment } from 'react'
import List from './List'
import ReceiptModal from './ReceiptModal'
import EmailCont from '../../../Common/Email/EmailCont'
import { idMaker } from '../../../../modules/Utils'
import useTitle from '../../../../elements/Hooks/useTitle'
const ids = idMaker()

function Receipts(props) {
  const { visibleEmail, emailDetails, emailFiles, emailLines, emailTemplate, onCancelEmail } = props
  useTitle('Receipts')
  return (
    <Fragment>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <ReceiptModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

Receipts.propTypes = {}
Receipts.defaultProps = {}

export default Receipts
